var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShowLoader)?_c('div',{staticClass:"loader-wrap"},[_c('b-spinner',{attrs:{"type":"grow","variant":"light","label":"loading..."}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }